export const cssVar = (name: string) => `var(${name})`;

export const varAlpha = (name: string, opacity: number) => `rgba(var(${name}-rgb), ${opacity})`;

export const themedAlpha = (color: string, opacity: number) => {
  const match = /^var\((--[a-z-]+)\)$/.exec(color);
  return match ? varAlpha(match[1], opacity) : `color-mix(in srgb, ${color} ${Math.round(opacity * 100)}%, transparent)`;
};

export const tone = {
  primary: cssVar('--primary'),
  onPrimary: cssVar('--on-primary'),
  secondary: cssVar('--secondary'),
  onSecondary: cssVar('--on-secondary'),
  accent: cssVar('--accent'),
  onAccent: cssVar('--on-accent'),
  success: cssVar('--success'),
  onSuccess: cssVar('--on-success'),
  warning: cssVar('--warning'),
  onWarning: cssVar('--on-warning'),
  danger: cssVar('--danger'),
  onDanger: cssVar('--on-danger'),
  info: cssVar('--info'),
  disabled: cssVar('--text-disabled'),
  text: cssVar('--text-main'),
  textSecondary: cssVar('--text-secondary'),
  textMuted: cssVar('--text-muted'),
  border: cssVar('--border'),
  borderStrong: cssVar('--border-strong'),
  body: cssVar('--bg-body'),
  card: cssVar('--bg-card'),
  cardHover: cssVar('--bg-card-hover'),
};
